import { Controller, ControllerRenderProps, FieldValues, useFormContext } from 'react-hook-form';
import { ErrorMessage } from '@components/error/src/error-message';
import { LabelPrimary } from '@components/label';
import { Select, SelectOption } from '@components/select';

import { ControlledInputSelectProps, SelectItem } from './controlled-input-select.type';

export const ControlledInputSelect = <T extends SelectItem>({
  fieldRegisterName,
  options,
  label,
  rules,
  isDisabled,
  onChange,
}: ControlledInputSelectProps<T>) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const handleEventSelectorChange = (
    field: ControllerRenderProps<FieldValues, typeof fieldRegisterName>,
    e: React.FormEvent<HTMLSelectElement>
  ) => {
    field.onChange(e.currentTarget.value);
    if (onChange) onChange(e);
  };
  return (
    <Controller
      name={fieldRegisterName}
      control={control}
      rules={rules}
      render={({ field }) => (
        <fieldset className='flex flex-col'>
          <LabelPrimary htmlFor={fieldRegisterName}>{label}</LabelPrimary>
          <Select
            {...field}
            readOnly={isDisabled}
            hasError={!!errors[fieldRegisterName]}
            onChange={(e) => handleEventSelectorChange(field, e)}>
            <SelectOption label={label} value={''} disabled />
            {options?.map((option) => <SelectOption key={option.id} value={option.id} label={option.name} />)}
          </Select>
          <ErrorMessage name={fieldRegisterName} />
        </fieldset>
      )}
    />
  );
};
